import React from "react";
import "../Css/Python.css";

import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const PyList = () => {
  const [loading, setLoading] = useState(false);
  let [color] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div className="container-fluid background_py">
              <div className="row">
                <Navbar />

                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/pyLogo.png"}
                      width="60%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <div
              className="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">List in Python</h1>
                <hr style={{ color: "white" }}></hr>
                <div>
                  <p>
                    In this tutorial, we will learn about the list in Python. We
                    will discuss how to create, slice, insert, update and remove
                    an element from Python list with example.
                  </p>
                </div>
                <br />
                <br />

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <h1 className="py_h1">What is the List</h1>
                  <ul style={{ marginLeft: "70px" }}>
                    <li>The List is a sequence data type in Python.</li>
                    <li>The List can store different types of data.</li>
                    <li>The List can have any number of items.</li>
                    <li>
                      Each item of the list has an index number, starting from
                      0.
                    </li>
                    <li>
                      The List is mutable(we can change the value of a list).
                    </li>
                  </ul>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>How to Create a List</h3>
                  </div>
                  <p>
                    We can create a list by pacing all items inside square
                    brackets [ ] separated by comma (,).
                  </p>
                  <pre>
                    <code>
                      {`
                     #Empty List, contain nothing
                     n=[]
                      
                     #List with numbers
                     n=[11, 22, 33, 44, 55]
                      
                     #List with Text
                     color=["Red", "Green", "Yellow"]
                      
                     #List with mixed items
                     n=[1, 2, "Hello", [99, 88]]
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Access Element of the List</h1>

                <hr style={{ color: "white" }} />
                <p>
                  We can access the element of the list by referring index
                  number in square [ ] brackets.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>
                      Example : Access the element of the list by referring
                      index number in square [ ] brackets.
                    </h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     #creating a list
                     n=[11, 22, 33, 44, 55]
                      
                     #print all the items
                     print(n)
                      
                     #print first item of the list
                     #index of the first item is 0
                     print(n[0])
                      
                     #index of the second item is 1
                     print(n[1])
                      
                     #index of the last item is -1
                     print(n[-1])
                      
                     #index of the second last item is -2
                     print(n[-2])
                       `}
                    </code>
                  </pre>
                </div>

                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Slicing List in Python</h1>

                <hr style={{ color: "white" }} />
                <p>
                  We can access the sublist of a list using a slicing operator (
                  : ) in square brackets [ ]. Syntax of the slicing is [start :
                  stop : step]..
                </p>

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     n=[11, 22, 33, 44, 55, 66, 77, 88]
 
                     #print all the elements
                     print(n)
                     print(n[:])
                      
                     #print first to fifth element (index 0 to 4)
                     print(n[0:5])
                      
                     #print element of index 2 to 4
                     print(n[2:5])
                      
                     #print element of index 2 to last
                     print(n[2:])
                      
                     #print element of index 2 to second last
                     print(n[1:-1])
                      
                     #print value of index (0,2,4,6)
                     print(n[0:8:2])
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Modify Lists in Python</h1>

                <hr style={{ color: "white" }} />
                <p>
                  Lists are mutable, so we can change or update the values of
                  the list. We can use an index of the list to change the items.
                </p>

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Using the List’s Index</h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     n=[11, 22, 33, 44, 55]
                     print(n)
                      
                     #change first and third value
                     n[0]=99
                     n[2]=100
                     print(n)
                      
                     #output : [99, 22, 100, 44, 55]
                       `}
                    </code>
                  </pre>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Using the List’s Slicing</h3>
                  </div>
                  <pre>
                    <code>{`
                        n=[11, 22, 33, 44, 55]
                        print(n)
 
                        #change 2nd to 4th item
                        n[1:4]=[1, 2, 3]
                        print(n)
 
                        #output : [11, 1, 2, 3, 55] 
                        `}</code>
                  </pre>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Adding Two List</h3>
                  </div>
                  <pre>
                    <code>{`
                        list1 = [1, 2, 3]
                        list2 = [9, 8, 7]
                        list3 = list1 + list2
                        print(list3)
                         
                        #output : [1, 2, 3, 9, 8, 7] 
                        `}</code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Modify List using Methods</h1>

                <hr style={{ color: "white" }} />
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <ul>
                    <li>
                      <span style={{ fontWeight: "bold" }}>append() – </span>Add
                      a single item to the end of the list and update the list.
                      Syntax: list.append( item )
                    </li>
                  </ul>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>{`
                        n=[11, 22, 33, 44, 55]
                        print(n)
                         
                        #using append() method
                        n.append(99)
                        print(n)
                         
                        #output : [11, 22, 33, 44, 55, 99] 
                        `}</code>
                  </pre>
                  <br />
                  <ul>
                    <li>
                      <span style={{ fontWeight: "bold" }}>extend() – </span> It
                      can add multiple items to the list at the end. Syntax:
                      list1.extend( list2 )
                    </li>
                  </ul>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>{`
                        n=[11, 22, 33, 44, 55]
                        print(n)
                         
                        #using extend() method
                        list1=[1, 2, 3]
                        n.extend(list1)
                        print(n)
                         
                        #output : [11, 22, 33, 44, 55, 1, 2, 3] 
                        `}</code>
                  </pre>
                  <br />
                  <ul>
                    <li>
                      <span style={{ fontWeight: "bold" }}>insert() – </span>It
                      can insert a new item at the specific index, rest items
                      will shift to the right. Syntax: list.insert( index, item
                      )
                    </li>
                  </ul>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>{`
                        n=[11, 22, 33, 44, 55]
                        print(n)
                         
                        #using insert() method
                        n.insert(1,99)
                        print(n)
                         
                        #output : [11, 99, 22, 33, 44, 55] 
                        `}</code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Delete an Item from the List</h1>

                <hr style={{ color: "white" }} />
                <p>
                  In Python, we can delete items from the list using Python’s
                  method remove(), pop(), clear() or we can use del keyword.
                </p>
                <br />
                <br />
                <p>
                  <span style={{ fontWeight: "bold" }}>
                    del Keyword in Python
                  </span>
                  <br />
                  We can delete one, more or complete list using del keyword in
                  Python. In Python del keyword uses index or slice to remove
                  items.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>{`
                        #delete first item
                        n=[11, 22, 33, 44, 55]
                        del n[0]
                        print(n)    #output: [22, 33, 44, 55]
                         
                        #delete multiple items
                        n=[11, 22, 33, 44, 55]
                        del n[1:4]
                        print(n)    #output: [11, 55]
                         
                        #delete entire list
                        n=[11, 22, 33, 44, 55]
                        del n
                        print(n)
                        #output: error, n is not define
                        #we remove entire list 
                        `}</code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Delete List using Python’s Methods</h1>

                <hr style={{ color: "white" }} />
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <ul style={{ textAlign: "center" }}>
                    <li>
                      remove() – In Python, remove() method delete given item.
                    </li>
                    <li>pop() – It removes the last item of the list.</li>
                    <li>pop(index) – It removes an item of the given index.</li>
                    <li>clear() – Remove all the items of the list.</li>
                  </ul>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>{`
                        #delete an item by value
                        n=[11, 22, 33, 44, 55]
                        n.remove(22)
                        print(n)    #output: [11, 33, 44, 55]
                         
                        #delete last item of the list
                        n=[11, 22, 33, 44, 55]
                        n.pop()
                        print(n)    #output: [11, 22, 33, 44]
                         
                         
                        #delete an item by index
                        n=[11, 22, 33, 44, 55]
                        n.pop(2)
                        print(n)    #output: [11, 22, 44, 55]
                         
                        #delete all items
                        n=[11, 22, 33, 44, 55]
                        n.clear()
                        print(n)    #output: [ ] 
                        `}</code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
              <div className="row mt-3">
                <h1 className="py_h1">Useful Functions of the List</h1>

                <hr style={{ color: "white" }} />

                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <ul style={{ textAlign: "center" }}>
                    <li>
                      count() – Return count of how many times an element is in
                      the list.
                    </li>
                    <li>
                      index() – It returns the index of the first matching
                      element
                    </li>
                    <li>
                      sort() – sort the list in ascending or descending order.
                    </li>
                    <li>reverse() – It reverses the list.</li>
                  </ul>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>{`
                        n=[11, 22, 11, 88, 33, 11, 55]
                        print(n)
                        print(n.count(11))  #count an item in the list
                        print(n.index(33))  #return index of 33 in the list
                         
                        #sort the list in ascending
                        n=[11, 22, 11, 88, 33, 11, 55]
                        n.sort()
                        print(n)
                         
                        #sort the list in descending
                        n.sort(reverse=True)
                        print(n)
                         
                        #reverse the list
                        n=[11, 22, 11, 88, 33, 11, 55]
                        n.reverse()
                        print(n) 
                        `}</code>
                  </pre>
                  <br />
                  <h1 className="py_h1">Aggregate Function</h1>
                  <ul
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <li>len() – Return length of the list.</li>
                    <li>min() – Return minimum value of the list.</li>
                    <li>max() – Return maximum value of the list.</li>
                    <li>sum() – Return sum of the values of the list.</li>
                  </ul>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example</h3>
                  </div>
                  <pre>
                    <code>{`
                        #aggregate function
                        print(len(n))
                        print(min(n))
                        print(max(n))
                        print(sum(n)) 
                        `}</code>
                  </pre>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
            <PyFooter />
          </>
        )}
      </div>
    </>
  );
};
